module.exports = __webpack_public_path__ + "static/media/Volume.031e9c84.svg";